<div class="sidebar">
	<app-sidebar-header [title]="'Edit Passengers'">
		<div actions><button class="button button--small" (click)="TAP_saveSidebar()" aria-label="Save changes"
			*ngIf="!form.pristine">Save</button></div>
	</app-sidebar-header>
	<div class="sidebar__body sl--scrollable" #sidebar__body>
		<div class="sidebar__form">
			<form [formGroup]="form">
				<app-counter-input formControlName="adults" [min]=1 [max]=count [label]="'Adults'"
					[description]="'Over 15 years'">
				</app-counter-input>
				<app-counter-input formControlName="youngAdults" [min]=0 [max]=count [label]="'Young adults'"
					[description]="'12 to 15 years'">
				</app-counter-input>
				<app-counter-input formControlName="children" [min]=0 [max]=count [label]="'Children'"
					[description]="'2 to 11 years'">
				</app-counter-input>
				<app-counter-input formControlName="infants" [min]=0 [max]=count [label]="'Infants'"
					[description]="'Under 2 years'">
				</app-counter-input>
			</form>
		</div>
		<div class="extras__helper with-notification">
			<div class=""><a class="link extras-feature__link" aria-label="Close dialog"
					(click)="TAP_handleClose()" href="javascript:;" role="button">Close this
					window</a></div>
		</div>
	</div>
	<div #sidebar__footer class="sidebar__footer">
		<div class="sidebar__footer-options sidebar__footer-options--confirmation" *ngIf="!form.pristine">
			<button class="button top-gap float-right" (click)="TAP_saveSidebar()">Save changes</button>
		</div>
	</div>
</div>
